const nationalities = [
  "Afghan",
  "Albanian",
  "Algerian",
  "American",
  "Andorran",
  "Angolan",
  "Argentine",
  "Armenian",
  "Australian",
  "Austrian",
  "Azerbaijani",
  "Bahamian",
  "Bahraini",
  "Bangladeshi",
  "Barbadian",
  "Belarusian",
  "Belgian",
  "Belizean",
  "Beninese",
  "Bhutanese",
  "Bolivian",
  "Brazilian",
  "British",
  "Bulgarian",
  "Cabo Verdean",
  "Cambodian",
  "Cameroonian",
  "Canadian",
  "Chadian",
  "Chilean",
  "Chinese",
  "Colombian",
  "Comorian",
  "Congolese",
  "Costa Rican",
  "Croatian",
  "Cuban",
  "Cypriot",
  "Czech",
  "Danish",
  "Dominican",
  "Ecuadorian",
  "Egyptian",
  "Eritrean",
  "Estonian",
  "Ethiopian",
  "Finnish",
  "French",
  "Gabonese",
  "Gambian",
  "Georgian",
  "German",
  "Ghanaian",
  "Greek",
  "Grenadian",
  "Guatemalan",
  "Guinean",
  "Guyanese",
  "Haitian",
  "Honduran",
  "Hungarian",
  "Icelandic",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Ivorian",
  "Jamaican",
  "Japanese",
  "Jordanian",
  "Kazakh",
  "Kenyan",
  "Kosovan",
  "Kuwaiti",
  "Kyrgyz",
  "Lao",
  "Latvian",
  "Lebanese",
  "Liberian",
  "Libyan",
  "Lithuanian",
  "Macedonian",
  "Malagasy",
  "Malawian",
  "Malaysian",
  "Maldivian",
  "Malian",
  "Maltese",
  "Marshallese",
  "Mauritanian",
  "Mauritian",
  "Mexican",
  "Moldovan",
  "Monegasque",
  "Mongolian",
  "Montenegrin",
  "Moroccan",
  "Mozambican",
  "Namibian",
  "Nauruan",
  "Nepalese",
  "Nicaraguan",
  "Nigerian",
  "Norwegian",
  "of Antigua and Barbuda",
  "of Bosnia and Herzegovina",
  "of Botswana",
  "of Brunei Darussalam",
  "of Burkina Faso",
  "of Burundi",
  "of Djibouti",
  "of Dominica",
  "of Equatorial Guinea",
  "of Fiji",
  "of Guinea-Bissau",
  "of Kiribati",
  "of Lesotho",
  "of Liechtenstein",
  "of Luxembourg",
  "of Myanmar",
  "of New Zealand",
  "of Niger",
  "of Pakistan",
  "of Palau",
  "of Palestine",
  "of Papua New Guinea",
  "of Qatar",
  "of Saint Kitts and Nevis",
  "of Saint Vincent and the Grenadines",
  "of Sao Tome and Principe",
  "of Seychelles",
  "of the Central African Republic",
  "of the Democratic People's Republic of Korea",
  "of the Democratic Republic of the Congo",
  "of the Federated States of Micronesia",
  "of the Republic of Korea",
  "of the Solomon Islands",
  "of the United Arab Emirates",
  "of Timor-Leste",
  "of Trinidad and Tobago",
  "of Vanuatu",
  "of Vatican City",
  "Omani",
  "Panamanian",
  "Paraguayan",
  "Peruvian",
  "Philippine",
  "Polish",
  "Portuguese",
  "Romanian",
  "Russian",
  "Rwandan",
  "Saint Lucian",
  "Salvadorian",
  "Samoan",
  "Saudi Arabian",
  "Senegalese",
  "Serbian",
  "Sierra Leonean",
  "Singaporean",
  "Slovak",
  "Slovene",
  "Somali",
  "South African",
  "South Sudanese",
  "Sri Lankan",
  "Sudanese",
  "Surinamese",
  "Swazi",
  "Swedish",
  "Swiss",
  "Syrian",
  "Taiwanese",
  "Tajik",
  "Tanzanian",
  "Thai",
  "Togolese",
  "Tongan",
  "Tunisian",
  "Turkish",
  "Turkmen",
  "Tuvaluan",
  "Ugandan",
  "Ukrainian",
  "Uruguayan",
  "Uzbek",
  "Venezuelan",
  "Vietnamese",
  "Yemeni",
  "Zambian",
  "Zimbabwean",
];

const nationalityValues = Array.from(new Set(nationalities)).map((label) => ({
  text: label,
  value: label,
}));

export default nationalityValues;
